// extracted by mini-css-extract-plugin
module.exports = {"loader":"ListSlide_loader__IVHDH","slide":"ListSlide_slide__Lmpn1"};